import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { Details } from '../../../components';

interface HeaderProps
  extends Readonly<{
    title: string;
    coupleNames?: string;
  }> {}

export const Header: React.FC<HeaderProps> = ({ title, coupleNames }) => (
  <>
    <TextV2
      typographyVariant="hed6"
      marginTop={['24px', null, '4px']}
      textAlign="center"
    >
      {title}
    </TextV2>
    {coupleNames && <Details coupleNames={coupleNames} />}
  </>
);
